




import Vue from "vue";
import UsersDetails from "./UsersDetails.vue";
import UsersIndex from "./UsersIndex.vue";

export default Vue.extend({
  data() {
    return {
      ready: false
    };
  },
  components: {
    UsersDetails,
    UsersIndex 
  },
  computed: {
    currentView: function(): string {
      return !!this.$route.params &&
        !!this.$route.params.id &&
        this.$route.params.id.length > 0
        ? "UsersDetails"
        : "UsersIndex";
    }
  },
  mounted() {
    this.ready = true;
  }
});
